import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { GLOBAL } from "./global";
import { Methods } from "../shared/methods";

@Injectable({
  providedIn: "root",
})
export class TaxService {
  public mtds: Methods = new Methods();

  public url: string;
  public urlTaxExempt: string;
  public urlCountries: string;
  public token;
  public headers;

  constructor(private _router: Router, private _http: HttpClient) {
    this.url = GLOBAL.url + "/state/";
    this.urlTaxExempt = GLOBAL.url + "/taxexemption/";
    this.urlCountries = GLOBAL.url + "/country/";
    this.token = JSON.parse(localStorage.getItem("token"));
    if (this.token === "undefined") {
      this.token = null;
    }
    this.headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
  }

  save(json): Observable<any> {
    console.log(json);
    if (json.id === null) {
      return this.create(json);
    } else {
      return this.edit(json.id, json);
    }
  }

  edit(id, json): Observable<any> {
    return this.petition(this.url + "edit/" + id, json);
  }
  newTaxExempt(json): Observable<any> {
    return this.petition(this.urlTaxExempt + "new", json);
  }
  editTaxExempt(id, json): Observable<any> {
    return this.petition(this.urlTaxExempt + "edit/" + id, json);
  }
  listTaxExempt(id): Observable<any> {
    return this.petition(this.urlTaxExempt + "listbycompany/" + id);
  }
  deleteTaxExempt(id): Observable<any> {
    return this.petition(this.urlTaxExempt + "remove/" + id);
  }

  create(json): Observable<any> {
    return this.petition(this.url + "new", json);
  }

  delete(id): Observable<any> {
    return this.petition(this.url + "remove/" + id);
  }

  showOne(id): Observable<any> {
    return this.petition(this.url + "detail/" + id);
  }

  showAll(byCountry = null): Observable<any> {
    return this.petition(
      this.url + (byCountry === null ? "list" : "listbycountry/" + byCountry)
    );
  }

  getCoutnries(): Observable<any> {
    return this.petition(this.urlCountries + "list");
  }

  getCountries(): Observable<any> {
    return this.petition(this.urlCountries + "list");
  }

  petition(url, json = null, type = null): Observable<any> {
    this.token = JSON.parse(localStorage.getItem("token"));
    let paramas, response;
    paramas = "authorization=" + this.token;

    if (json != null) {
      json = JSON.stringify(json);
      paramas = paramas + "&json=" + json;
    }

    if (type != null) {
      paramas = paramas + "&type=" + type;
    }

    response = this._http.post(url, paramas, { headers: this.headers }).pipe(
      map((res: any) => res),
      catchError((error) => {
        if (error.status === 404) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        }
        throw error;
      })
    );

    return response;
  }
}
